import { submitSignedDeclarationV3 } from './http'
import { SignedDeclarationRequest, SignedDeclarationResponse } from '../models/types'

// eslint-disable-next-line import/prefer-default-export
export async function submitSignedDeclaration(
  request: SignedDeclarationRequest,
): Promise<SignedDeclarationResponse> {
  return submitSignedDeclarationV3(request)
}
